import { useMutation, useQueryClient } from '@tanstack/react-query'
import { addToWishlist } from '@/api/wishlist'
import type { PlayingEntryWithGame, PlayedEntryWithGame } from '@/types'

export function useDemoteToWishlist(groupId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (gameId: string) => addToWishlist(groupId, gameId),
    onMutate: async (gameId) => {
      await queryClient.cancelQueries({ queryKey: ['playing', groupId] })
      await queryClient.cancelQueries({ queryKey: ['played', groupId] })
      const previousPlaying = queryClient.getQueryData(['playing', groupId])
      const previousPlayed = queryClient.getQueryData(['played', groupId])
      queryClient.setQueryData<PlayingEntryWithGame[]>(['playing', groupId], (old = []) =>
        old.filter((e) => e.gameId !== gameId)
      )
      queryClient.setQueryData<PlayedEntryWithGame[]>(['played', groupId], (old = []) =>
        old.filter((e) => e.gameId !== gameId)
      )
      return { previousPlaying, previousPlayed }
    },
    onError: (_err, _gameId, context) => {
      if (context?.previousPlaying) queryClient.setQueryData(['playing', groupId], context.previousPlaying)
      if (context?.previousPlayed) queryClient.setQueryData(['played', groupId], context.previousPlayed)
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['playing', groupId] })
      queryClient.invalidateQueries({ queryKey: ['played', groupId] })
      queryClient.invalidateQueries({ queryKey: ['wishlist', groupId] })
    },
  })
}
